import React, { useState } from 'react';
import './App.css';
import ImageGenerator from './components/ImageGenerator';
import RecipeGenerator from './components/RecipeGenerator';
import ChatComponent from './components/ChatComponent';

function App() {
  console.log(process.env.REACT_APP_API_URL); // for testing

  const [activeTab, setActiveTab] = useState('image-generator');

  const handleTabChange = (tab) => {
    //alert(tab)
    setActiveTab(tab)
  };

  return (
    <div className="App">
      <button className={activeTab === 'image-generator' ? 'active' : ''}
      onClick ={() => handleTabChange('image-generator')}>
        Image Generator
        </button>
      <button className={activeTab === 'chat' ? 'active' : ''}
      onClick ={() => handleTabChange('chat')}>
        Ask AI
        </button>
      <button className={activeTab === 'recipe-generator' ? 'active' : ''}
      onClick ={() => handleTabChange('recipe-generator')}>
        Recipe Generator
        </button>

        <div>
          {activeTab === 'image-generator' && <ImageGenerator/>}
          {activeTab === 'chat' && <ChatComponent/>}
          {activeTab === 'recipe-generator' && <RecipeGenerator/>}
        </div>
    </div>
  );
}

export default App;